import { render } from "./generateDialog.vue?vue&type=template&id=4a2a62a6&scoped=true&lang=pug"
import script from "./generateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./generateDialog.vue?vue&type=script&setup=true&lang=js"

import "./generateDialog.vue?vue&type=style&index=0&id=4a2a62a6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4a2a62a6"

export default script